export function unlockInput(id) {
    var input = document.getElementById(id);
    input.focus();
}